import React from 'react';
import 'twin.macro';
import { createPortal } from 'react-dom';
import { DragOverlay, useDndContext } from '@dnd-kit/core';

export function DraggableOverlay() {
  const { active } = useDndContext();

  return createPortal(
    <DragOverlay dropAnimation={null}>
      {active ? (
        <div tw="inline-flex items-center gap-x-2 bg-white p-1 rounded">
          {active?.data?.current?.icon} {active?.data?.current?.title}
        </div>
      ) : null}
    </DragOverlay>,
    document.body,
  );
}
